import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import axiosMiddleware from 'redux-axios-middleware';
import createSagaMiddleware from 'redux-saga';
import reducers from './reducers';
import rootSaga from './sagas';

import tokenInterceptor from './interceptors/token';
import actionsInterceptor from './interceptors/actions';

import {apiUrl} from './libs/api';
import {socketClient} from './libs/socket';
import socketClientRedux from './libs/socket-client-redux';

import dataInterceptor from './libs/mk-womanizer/interceptor';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const sagaMiddleware = createSagaMiddleware(rootSaga);

const axiosMiddlewareConfig = {
    interceptors: {
        request: [
            tokenInterceptor.request,
        ],
        response: [
            tokenInterceptor.response,
            actionsInterceptor.response,
            dataInterceptor.response,
        ]
    }
};

let store = createStore(
    reducers,
    {},
    composeEnhancers(
        applyMiddleware(thunk, axiosMiddleware(apiUrl, axiosMiddlewareConfig), socketClientRedux(socketClient), sagaMiddleware),
    )
);

sagaMiddleware.run(rootSaga);

export default store;
